module.exports = __webpack_public_path__ + "static/media/offer.1b266542.svg";